import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReactGA from 'react-ga4';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    ReactGA.initialize('G-CYQDVGWVZW');

    ReactGA.send({ hitType: 'pageview', page: location.pathname, title: location.pathname });
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  location: PropTypes.shape().isRequired,
};

export default withRouter(ScrollToTop);
